import { defineMessages } from 'react-intl'

export default defineMessages({
  redirectCountdown: {
    id: 'containers.PublicLiveSessionRedirectPage.redirectCountdown',
    defaultMessage: "You will be redirected to the session in {time}",
  },
  waitMessage: {
    id: 'containers.PublicLiveSessionRedirectPage.waitMessage',
    defaultMessage: 'The session will open automatically when it’s time. Please wait...',
  },
  waitingMessage: {
    id: 'containers.PublicLiveSessionRedirectPage.waitingMessage',
    defaultMessage: "Waiting for the session to become joinable...",
  },
  readyToJoin: {
    id: 'containers.PublicLiveSessionRedirectPage.readyToJoin',
    defaultMessage: 'You can now join the session by clicking the button below.',
  },
  joinNow: {
    id: 'containers.PublicLiveSessionRedirectPage.joinNow',
    defaultMessage: "Join Now",
  },
  buttonDisabledHint: {
    id: 'containers.PublicLiveSessionRedirectPage.buttonDisabledHint',
    defaultMessage: 'The "Join Now" button will be enabled when the session is ready.',
  },
  liveSessionNotFound: {
    id: 'containers.PublicLiveSessionRedirectPage.liveSessionNotFound',
    defaultMessage: 'Sorry, we could not find your LiveSession. Please contact your PM.',
  },
  testMic: {
    id: 'containers.PublicLiveSessionRedirectPage.testMic',
    defaultMessage: "Test Your Mic",
  },
  hideMicTest: {
    id: 'containers.PublicLiveSessionRedirectPage.hideMicTest',
    defaultMessage: "Stop Mic Test",
  },
  micTestTitle: {
    id: 'containers.PublicLiveSessionRedirectPage.micTestTitle',
    defaultMessage: "Mic Test",
  },
  micInstructions: {
    id: 'containers.PublicLiveSessionRedirectPage.micInstructions',
    defaultMessage:
      "Click the button to test your microphone. Your browser may ask for permission. Choose 'Allow' to continue.",
  },
  startMicTest: {
    id: 'containers.PublicLiveSessionRedirectPage.startMicTest',
    defaultMessage: "Start Mic Test",
  },
  requestingMic: {
    id: 'containers.PublicLiveSessionRedirectPage.requestingMic',
    defaultMessage: "Requesting microphone access...",
  },
  micWorking: {
    id: 'containers.PublicLiveSessionRedirectPage.micWorking',
    defaultMessage: "Your microphone is working!",
  },
  micError: {
    id: 'containers.PublicLiveSessionRedirectPage.micError',
    defaultMessage: "We could not access your microphone. Check your browser settings.",
  },
  liveSessionPreferences: {
    id: 'containers.PublicLiveSessionRedirectPage.liveSessionPreferences',
    defaultMessage: "Please wear headphones.\n Chrome browser is preferred."
  },
  allowMicrophoneAccessInstructions: {
    id: 'containers.PublicLiveSessionRedirectPage.allowMicrophoneAccessInstructions',
    defaultMessage: `
      <ol>
        <li>When your browser asks for permission, click <strong>Allow</strong>.</li>
        <li>If you don't see the prompt, make sure your browser isn’t blocking popups or media access.</li>
        <li>If access was previously denied, click the padlock icon in the address bar and enable the microphone.</li>
      </ol>
    `
  }
})
